import isEmpty from 'lodash.isempty';
import { useQueryClient } from '../../lib';
import { getAuthMemberKey, getAuthTokenKey } from '../../utils/keys';
const findAuthMemberInAuthToken = (queryClient) => {
    const queries = queryClient.getQueriesData({
        queryKey: getAuthTokenKey(),
    });
    let authMember;
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const authToken = query === null || query === void 0 ? void 0 : query[1];
        authMember = {
            ...authMember,
            ...authToken === null || authToken === void 0 ? void 0 : authToken.member,
        };
    });
    return authMember;
};
const findAuthMember = (queryClient) => {
    const queries = queryClient.getQueriesData({
        queryKey: getAuthMemberKey(),
    });
    let authMember;
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const data = query === null || query === void 0 ? void 0 : query[1];
        authMember = {
            ...authMember,
            ...data,
        };
    });
    return authMember;
};
export const useCachedAuthMember = () => {
    const queryClient = useQueryClient();
    const authMember = {
        ...findAuthMember(queryClient),
        ...findAuthMemberInAuthToken(queryClient),
    };
    if (!isEmpty(authMember))
        return authMember;
};
//# sourceMappingURL=useCachedAuthMember.js.map